import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import Logo from './Logo';
import { useBrand } from './BrandProvider';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const brand = useBrand();
  
  return (
    <footer className="bg-brand text-white mt-16">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <Logo size="small" clickable={true} />
            </div>
            <div className="flex gap-3">
              {brand.social.facebook && (
                <a href={brand.social.facebook} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-brand-dark rounded-full flex items-center justify-center hover:bg-white hover:text-brand transition-colors">
                  <Facebook size={16} />
                </a>
              )}
              {brand.social.twitter && (
                <a href={brand.social.twitter} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-brand-dark rounded-full flex items-center justify-center hover:bg-white hover:text-brand transition-colors">
                  <Twitter size={16} />
                </a>
              )}
              {brand.social.instagram && (
                <a href={brand.social.instagram} target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-brand-dark rounded-full flex items-center justify-center hover:bg-white hover:text-brand transition-colors">
                  <Instagram size={16} />
                </a>
              )}
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-bold mb-4">Produits</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><a href="/" className="hover:text-accent transition-colors">Toile De Store</a></li>
              <li><a href="/store-droit" className="hover:text-accent transition-colors">Toile de Store Droit</a></li>
              <li><a href="/store-double-pente" className="hover:text-accent transition-colors">Toile de Store à Double Pente</a></li>
              <li><a href="/lambrequin" className="hover:text-accent transition-colors">Lambrequin Seul</a></li>
              <li><a href="/pergola" className="hover:text-accent transition-colors">Toile De Pergola</a></li>
              <li><a href="/brise-vue" className="hover:text-accent transition-colors">Brise-Vue De Balcon</a></li>
              <li><a href="/toile-au-metre" className="hover:text-accent transition-colors">Toile de Store au Metre</a></li>
              <li><a href="/devis-marquage-flocage" className="hover:text-accent transition-colors">Marquage/Flocage</a></li>
              <li><a href="/devis-marquage-lumineux-flocage" className="hover:text-accent transition-colors">Marquage Lumineux/Flocage</a></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-bold mb-4">Service client</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><a href="/contact" className="hover:text-accent transition-colors">Contact</a></li>
              <li><a href="/garantie" className="hover:text-accent transition-colors">Garantie</a></li>
              <li><a href="/faq" className="hover:text-accent transition-colors">FAQ</a></li>
              <li><a href="/blog" className="hover:text-accent transition-colors">Blog</a></li>
            </ul>
          </div>

          {/* Contact - Dynamic from brand config */}
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>{brand.contact.phoneDisplay}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <span>{brand.contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>{brand.contact.address.street}<br />{brand.contact.address.postalCode} {brand.contact.address.city}, France</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex justify-between items-center text-sm text-gray-300">
            <p>© {currentYear} {brand.name}. Tous droits réservés.</p>
            <div className="flex gap-6">
              <a href="/mentions-legales" className="hover:text-accent transition-colors">Mentions légales</a>
              <a href="/cgv" className="hover:text-accent transition-colors">CGV</a>
              <a href="#" className="hover:text-accent transition-colors">Politique de confidentialité</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;